var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyIcon05(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.45018 6.56296C6.08253 6.56296 4.1632 8.48231 4.1632 10.8499V11.1499H0.137207V10.8499C0.137207 6.25883 3.85905 2.53699 8.45018 2.53699V6.56296Z",
    fill: "url(#paint0_linear_79_8518)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8372 11.15V10.8501H15.8634V11.15C15.8634 15.7412 12.1414 19.463 7.55029 19.463V15.4371C9.91794 15.4371 11.8372 13.5176 11.8372 11.15Z",
    fill: "url(#paint1_linear_79_8518)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29982 0.5V8.44998L15.1999 4.54998L8.29982 0.5ZM7.70026 21.5L7.70028 13.55L0.800293 17.4499L7.70026 21.5Z",
    fill: "#4951FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_8518",
    x1: 8.09491,
    y1: 4.76314,
    x2: 1.27389,
    y2: 4.9526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A41CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4951FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_8518",
    x1: 7.90556,
    y1: 17.2369,
    x2: 14.7265,
    y2: 17.0473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A41CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4951FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyIcon05);
export default __webpack_public_path__ + "static/media/company-icon-05.abb9f8e2775cc3409bc3ea15ed18ff75.svg";
export { ForwardRef as ReactComponent };